import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CoalService } from './coal.service';
// import { resolve } from 'dns';
import { AppState } from 'app/store/app.states';
import { Store } from '@ngrx/store';
import { OcultarSpinner } from 'app/store/actions/utils.action';

@Injectable()
export class sparrowService {
  constructor(private coalService : CoalService,
    private readonly store: Store<AppState>) {}

    getReport(Dircall,body,nameReport) {
        return new Promise((resolve, reject) => {
            this.coalService.postServiceSparrow(Dircall, body).subscribe({
                next: (data: any) => {
                    const arr = new Uint8Array(data);
                    var file = new Blob([arr], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);
                    const a = document.createElement('a');
                    //Descargar PDF
                    a.href = fileURL;
                    a.download = nameReport;
                    a.click();
                    URL.revokeObjectURL(fileURL);
                    this.store.dispatch(OcultarSpinner());
                    resolve("Archivo generado correctamente");
                }, error: (error: any) => {
                    console.log("Error");
                    console.log(error);
                    this.store.dispatch(OcultarSpinner());
                    reject(error);
                }});
        });
    }

    getReportBase64(Dircall, body, nameReport) {
        return new Promise((resolve, reject) => {
            this.coalService.postServiceSparrow(Dircall, body).subscribe({
                next: (data: any) => {
                    const arr = new Uint8Array(data);
                    // const arr = data;
                    resolve(arr);
                },
                error: (error: any) => {
                    console.log("Error");
                    console.log(error);
                    reject(error);
                }
            });
        });
    }

}
